import React from "react";
import { graphql } from "gatsby";
import Page from "~/models/page";
import Frame from "~/views/layout/frame";
import SEO from "~/views/components/generic/seo";
import structuredData from "~/helpers/structured-data";
import Navigation from "~/views/compositions/navigation";
import Breadcrumbs from "~/views/compositions/breadcrumbs";

type Props = {
  data: any;
};

const ContactPage = ({ data }: Props) => {
  const page = new Page(data.page);

  return (
    <Frame>
      <Navigation />
      <Breadcrumbs urls={page.breadcrumb} />

      {/* Hero Section - Following index.tsx style */}
      <section className="flex flex-col lg:flex-row gap-8 lg:gap-0 items-start justify-center px-container py-6 sm:py-8 lg:py-10 w-full mx-auto">
        <div className="flex flex-col gap-4 sm:gap-5 w-full lg:max-w-[640px] px-0 lg:pr-10">
          <div className="flex flex-col gap-4 sm:gap-5">
            <h2 className="text-lg sm:text-xl leading-[32px] sm:leading-[44px] font-[800]">
              Get in Touch
            </h2>
            <h1 className="font-[800] text-[24px] sm:text-[32px] lg:text-[40px] leading-[36px] sm:leading-[48px] lg:leading-[74px] palt">
              プロダクト改善や共同開発の
              <br className="hidden lg:block" />
              ご相談、 講習の依頼など、 <br className="" />
              お気軽にご連絡ください。
            </h1>
          </div>
          <p className="font-[400] text-base sm:text-lg leading-[1.6] sm:leading-[2] palt tracking-[0.03em]">
            デジタルプロダクトの戦略やソフトウェア開発に関するご相談や、『unprinted』を活用した広報、マーケティング施策のご相談などメールにて承っております。
          </p>
        </div>

        {/* Contact info */}
        <div className="flex flex-col gap-0 w-full lg:max-w-[456px]">
          <div className="flex flex-col gap-6 sm:gap-8 p-4 sm:p-6 lg:p-8 bg-neutral-99 rounded-[24px] sm:rounded-[32px] lg:rounded-[40px]">
            <div className="flex flex-col gap-2">
              <span className="font-[500] text-sm sm:text-base palt">
                お問い合わせ先
              </span>
              <a
                href="mailto:enquiry@artefact.co.jp"
                className="font-[700] text-xl sm:text-2xl lg:text-[28px] break-all hover:opacity-70 transition-opacity"
              >
                enquiry@artefact.co.jp
              </a>
            </div>

            <p className="text-xs sm:text-sm text-neutral-50 leading-relaxed">
              ※ 営業目的でのお問い合わせはお断りしております。
            </p>
          </div>
        </div>
      </section>
    </Frame>
  );
};

export default ContactPage;

export const Head = ({ data }: Props) => {
  const page = new Page(data.page as any);
  const sd = structuredData(page);

  return <SEO page={page} sd={sd} />;
};

export const query = graphql`
  query ContactPage {
    page: pageMdx(
      filter: { frontmatter: { url: { pathname: { eq: "/contact/" } } } }
    ) {
      id
      frontmatter {
        id
        title
        description
        breadcrumb {
          ...UrlFields
        }
        url {
          ...UrlFields
        }
        type
        releasedAt
        updatedAt
      }
    }
  }
`;
